import { render, staticRenderFns } from "./groups-table.vue?vue&type=template&id=b634e368&scoped=true"
import script from "./groups-table.vue?vue&type=script&lang=js"
export * from "./groups-table.vue?vue&type=script&lang=js"
import style0 from "./groups-table.vue?vue&type=style&index=0&id=b634e368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b634e368",
  null
  
)

export default component.exports